// Custom JS Application Code
function validate_email_js(email) { var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; if(reg.test(email) == false) { return false; } return true; }
var ellipsisText = function (e, etc) { var wordArray = e.innerHTML.split(" "); while (e.scrollHeight > e.offsetHeight) { wordArray.pop(); e.innerHTML = wordArray.join(" ") + (etc || "..."); } };

function checkHeaderOffset() {
	var $window = $(window);
	var offset = $window.scrollTop();
	if (offset>=30) {
		$('#headerWrapper').addClass('scrolled');
	}else{
		$('#headerWrapper').removeClass('scrolled');
	}
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;
}
function pageScroll() {
	checkHeaderOffset();
}

function scrollToSlide(slideTo) {
	$('body,html').animate({ scrollTop: $('.'+slideTo).offset().top-$('header').height() }, 800);
}

function submitFilters() {
	var customURL = js_vars.vars.winesUrl;

	customURL += $('#filterVinha .filter-list li.active a').data('slug')+'/';
	customURL += $('#filterTipo .filter-list li.active a').data('slug')+'/';
	customURL += $('#filterCasta .filter-list li.active a').data('slug')+'/';

	document.location.href = customURL;
}

function initContactsMap() {
	var isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	var mapCenter = new google.maps.LatLng($('#google-maps').data('latitude'), $('#google-maps').data('longitude')),
		mapDirectionsDisplay = new google.maps.DirectionsRenderer();
	var markerDisabled =  { path: google.maps.SymbolPath.CIRCLE, scale: 13, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var markerEnabled = { path: google.maps.SymbolPath.CIRCLE, scale: 20, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var infoWindow = [];
	var infoWindowTitle = "Adega Luís Pato";
	var mapOptions = {
		center: mapCenter,
		zoom: 17,
		disableDefaultUI: false,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		scrollwheel: false,
		styles : mapStyles
	};
	if (isTouch) {
		mapOptions = {
			center: mapCenter,
			zoom: 17,
			disableDefaultUI: false,
			panControl: false,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			overviewMapControl: false,
			scrollwheel: false,
			draggable: false,
			styles : mapStyles
		};
	}

	var map = new google.maps.Map(document.getElementById("google-maps"), mapOptions);
	var oMarker = new google.maps.Marker({
		position: mapCenter,
		/*sName: "Marker Name",*/
		map: map,
		title:"Adega Luís Pato",
		icon: markerDisabled,
	});
	/*
	google.maps.event.addListener(oMarker, 'mouseover-', function () {
		infoWindow.open(map, this);
		oMarker.setIcon(markerEnabled);
	});
	google.maps.event.addListener(oMarker, 'mouseout-', function () {
		infoWindow.close();
		oMarker.setIcon(markerDisabled);
	});
	*/

	infoWindow = new google.maps.InfoWindow({ content: infoWindowTitle });
	google.maps.InfoWindow.prototype.isOpen = function(){
		var map = this.getMap();
		return (map !== null && typeof map !== "undefined");
	}
	google.maps.event.addListener(oMarker, 'click', function() {
		if (infoWindow.isOpen()) {
			infoWindow.close();
			oMarker.setIcon(markerDisabled);
		}else{
			infoWindow.open(map,oMarker);
			oMarker.setIcon(markerEnabled);
		}
	});
	google.maps.event.addListener(map, "click", function(event) {
		infowindow.close();
		oMarker.setIcon(markerDisabled);
	});

	mapDirectionsDisplay.setMap(map);
	google.maps.event.addDomListener(window, 'resize', function() { map.setCenter(mapCenter); });
}

function initVinhasMap() {
	var isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	var mapDirectionsDisplay = new google.maps.DirectionsRenderer();
	var markerDisabled =  { path: google.maps.SymbolPath.CIRCLE, scale: 13, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var markerEnabled = { path: google.maps.SymbolPath.CIRCLE, scale: 20, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var markers = $('.map-markers .map-marker');
	var mapCenter = new google.maps.LatLng(markers.eq(0).data('latitude'), markers.eq(0).data('longitude'))
	var mapOptions = {
		center: mapCenter,
		zoom: 17,
		disableDefaultUI: false,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		scrollwheel: false,
		styles : mapStyles
	};
	if (isTouch) {
		mapOptions = {
			center: mapCenter,
			zoom: 17,
			disableDefaultUI: false,
			panControl: false,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			overviewMapControl: false,
			scrollwheel: false,
			draggable: false,
			styles : mapStyles
		};
	}
	var map = new google.maps.Map(document.getElementById("google-maps"), mapOptions);
	var latlngbounds = new google.maps.LatLngBounds();

	google.maps.InfoWindow.prototype.isOpen = function(){
		var map = this.getMap();
		return (map !== null && typeof map !== "undefined");
	}

	var infoWindow = new google.maps.InfoWindow({
		content: '',
		pixelOffset: new google.maps.Size(80, 90)
	});
	for (var i = 0; i < markers.length; i++) {
		var data = markers.eq(i);
		var myLatlng = new google.maps.LatLng(data.data('latitude'), data.data('longitude'));
		var marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			title: data.data('title'),
			icon: markerDisabled,
		});
		mapMarkers.push(marker);
		google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
			return function() {
				if (infowindow.isOpen()) {
					for (var j=0;j<mapMarkers.length;j++) {
						mapMarkers[j].setIcon(markerDisabled);
					}
					$('.vinhas-swiper-wrapper').removeClass('is-active');
				}
				infowindow.setContent(content);
				infowindow.open(map,marker);
				marker.setIcon(markerEnabled);
				for (var j=0;j<mapMarkers.length;j++) {
					if (mapMarkers[j]===marker) {
						$('.vinhas-swiper-wrapper').eq(j).addClass('is-active');
						vinhasSwipers[j].update();
					}
				}
			};
		})(marker,data.data('title'),infoWindow));
		latlngbounds.extend(marker.position);

		if (i==0) {
			infoWindow.setContent(data.data('title'));
			infoWindow.open(map,marker);
			marker.setIcon(markerEnabled);
		}
	}
	/*
	google.maps.event.addListener(map, "click", function(event) {
		infoWindow.close();
		$('.vinhas-swiper-wrapper').removeClass('is-active');
		for (var j=0;j<mapMarkers.length;j++) {
			mapMarkers[j].setIcon(markerDisabled);
		}
	});
	*/

	map.setCenter(latlngbounds.getCenter());
	map.fitBounds(latlngbounds,80);
	//map.setZoom(map.getZoom() - 4);

	mapDirectionsDisplay.setMap(map);
	google.maps.event.addDomListener(window, 'resize', function() { /*map.setCenter(mapCenter);*/ latlngbounds.getCenter() });
}

function initVinhoDetailMap() {
	var isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	var mapDirectionsDisplay = new google.maps.DirectionsRenderer();
	var markerDisabled =  { path: google.maps.SymbolPath.CIRCLE, scale: 13, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var markerEnabled = { path: google.maps.SymbolPath.CIRCLE, scale: 20, fillColor: "#B9774A", fillOpacity: 1, strokeWeight: 0 };
	var markers = $('.map-markers .map-marker');
	var mapCenter = new google.maps.LatLng(markers.eq(0).data('latitude'), markers.eq(0).data('longitude'))
	var mapOptions = {
		center: mapCenter,
		zoom: 17,
		disableDefaultUI: false,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		scrollwheel: false,
		styles : mapStyles
	};
	if (isTouch) {
		mapOptions = {
			center: mapCenter,
			zoom: 17,
			disableDefaultUI: false,
			panControl: false,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			overviewMapControl: false,
			scrollwheel: false,
			draggable: false,
			styles : mapStyles
		};
	}
	var map = new google.maps.Map(document.getElementById("google-maps"), mapOptions);
	var latlngbounds = new google.maps.LatLngBounds();

	google.maps.InfoWindow.prototype.isOpen = function(){
		var map = this.getMap();
		return (map !== null && typeof map !== "undefined");
	}

	var infoWindow = new google.maps.InfoWindow({
		content: '',
		pixelOffset: new google.maps.Size(80, 90)
	});
	for (var i = 0; i < markers.length; i++) {
		var data = markers.eq(i);
		var myLatlng = new google.maps.LatLng(data.data('latitude'), data.data('longitude'));
		var marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			title: data.data('title'),
			icon: markerDisabled,
		});
		mapMarkers.push(marker);
		google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
			return function() {
				if (infowindow.isOpen()) {
					for (var j=0;j<mapMarkers.length;j++) {
						mapMarkers[j].setIcon(markerDisabled);
					}
					$('.wine-additional-info .image').removeClass('is-active');
				}
				infowindow.setContent(content);
				infowindow.open(map,marker);
				marker.setIcon(markerEnabled);
				for (var j=0;j<mapMarkers.length;j++) {
					if (mapMarkers[j]===marker) {
						$('.wine-additional-info .image').eq(j).addClass('is-active');
						vinhasSwipers[j].update();
					}
				}
			};
		})(marker,data.data('title'),infoWindow));
		latlngbounds.extend(marker.position);

		if (i==0) {
			infoWindow.setContent(data.data('title'));
			infoWindow.open(map,marker);
			marker.setIcon(markerEnabled);
		}
	}
	/*
	google.maps.event.addListener(map, "click", function(event) {
		infoWindow.close();
		$('.vinhas-swiper-wrapper').removeClass('is-active');
		for (var j=0;j<mapMarkers.length;j++) {
			mapMarkers[j].setIcon(markerDisabled);
		}
	});
	*/

	map.setCenter(latlngbounds.getCenter());
	if (mapMarkers.length==1) {
		map.setZoom(16);
	}else{
		map.fitBounds(latlngbounds,80);
	}

	mapDirectionsDisplay.setMap(map);
	google.maps.event.addDomListener(window, 'resize', function() { /*map.setCenter(mapCenter);*/ latlngbounds.getCenter() });
}

(function($) {
	"use strict"; // Start of use strict
	$(window).bind('hashchange');
	$(window).trigger('hashchange');
	$(window).scroll( function() { /*disableScroll();*/ pageScroll(); } );
	$(window).resize(function() { windowOnResize(); });
	$(window).ready(function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		//if ($(window).width()>=1024) { new WOW().init(); }

		//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

		$('.nav-toggle').bind('click',function(ev) {
			if ($('.nav-wrapper').hasClass('opened')) {
				$('.nav-wrapper').fadeOut(0,function() {
					$(this).removeClass('opened');
					$('#headerWrapper').removeClass('opened');
				});
				$(this).removeClass('is-active');
			}else{
				$('#headerWrapper').addClass('opened');
				$('.nav-wrapper').fadeIn(0,function() {
					$(this).addClass('opened');
				});
				$(this).addClass('is-active');
			}

			$(this).blur();
			ev.preventDefault();
		});

		$('.js-filter-toggle').bind('click',function(ev) {
			var parent = $(this).closest('.filter-group');
			var list = parent.find('ul');
			if (!parent.hasClass('is-opened')) {
				$('.filter-group.is-opened ul').slideUp();
				$('.filter-group').removeClass('is-opened');
			}
			list.slideToggle();
			parent.toggleClass('is-opened');
			$(this).blur(); ev.preventDefault();
		});

		$('.filter-list li a').bind('click',function(ev) {
			var parent = $(this).closest('.filter-group');
			var list = parent.find('ul');
			var itemToggle = parent.find('.js-filter-toggle');
			var defaultText = itemToggle.data('default');
			list.slideToggle();
			list.find('li').removeClass('active');
			$(this).closest('li').addClass('active');
			if ($(this).hasClass('default')) {
				itemToggle.text(defaultText);
			}else{
				itemToggle.text($(this).text());
			}

			$(this).blur(); ev.preventDefault();
		});

		$('.list-filters-wrapper .see-all-link a').bind('click',function(ev) {
			submitFilters();
			$(this).blur(); ev.preventDefault();
		});

		/* FORM */
		if ($('.block-form').length) {
			$('.js-form-submit').bind('click', function(ev) {
				var submit = $(this);
				var form = submit.closest('form');
				var acceptance = form.find('input[name="gdpr-acceptance"]');
				var isAccepted = acceptance.length ? acceptance.is(':checked') : true;


				// if (submit.hasClass('--disabled') || submit.attr('aria-disabled') === 'true') {
				// 	ev.preventDefault();
				// 	return;
				// }

				submit.toggleClass('--disabled', !isAccepted).attr('aria-disabled', isAccepted ? 'false' : 'true');
				form.find('.wpcf7-submit').trigger('click');

				submit.blur();
				ev.preventDefault();
			});
		}

	});
	$(window).on('load',function() {
		if ($('.vinhas-swiper-wrapper').length) {
			$('.vinhas-swiper-wrapper').each(function() {
				var id = $(this).attr('id');
				var newSwiper = new Swiper('#'+id+' .vinhas-swiper.swiper-container', {
					slidesPerView: 3,
					centeredSlides : false,
					spaceBetween: 0,
					loop: false,
					autoHeight: false,
					slidesPerGroup: 3,
					navigation: {
						nextEl: '#'+id+'.vinhas-swiper-wrapper .swiper-custom-next',
						prevEl: '#'+id+'.vinhas-swiper-wrapper .swiper-custom-prev',
					},
					//centeredSlides: true,
					/*
					freeMode: {
						enabled: true,
						//sticky: true,
					}
					*/
				});
				vinhasSwipers.push(newSwiper);
			});
		}

		if ($('.block-timeline').length) {
			$('.block-timeline').each(function() {
				var id = $(this).attr('id');
					if ($('#'+id+' .swiper-container').length) {
					var newSwiper = new Swiper('#'+id+' .swiper-container', {
						slidesPerView: 'auto',
						centeredSlides : false,
						spaceBetween: 40,
						loop: false,
						autoHeight: false,
						//slidesPerGroup: 3,
						navigation: {
							nextEl: '#'+id+' .swiper-custom-next',
							prevEl: '#'+id+' .swiper-custom-prev',
						},
						//centeredSlides: true,
						freeMode: {
							enabled: true,
						}
					});
				}
			});
		}

		if ($('#google-maps.in-contacts').length) {
			initContactsMap();
		}
		if ($('#google-maps.in-vinhas').length) {
			initVinhasMap();
		}
		if ($('#google-maps.in-vinho').length) {
			initVinhoDetailMap();
		}
	});

})(jQuery); // End of use strict


var browserWidth = 0;
var browserHeight = 0;
var mapStyles = [{"elementType":"labels","stylers":[{"visibility":"off"}]},{"elementType": "geometry","stylers": [{"color": "#ebe3cd"}]},{"elementType": "labels.text.fill","stylers": [{"color": "#523735"}]},{"elementType": "labels.text.stroke","stylers": [{"color": "#f5f1e6"}]},{"featureType": "administrative","elementType": "geometry.stroke","stylers": [{"color": "#c9b2a6"}]},{"featureType": "administrative.land_parcel","elementType": "geometry.stroke","stylers": [{"color": "#dcd2be"}]},{"featureType": "administrative.land_parcel","elementType": "labels.text.fill","stylers": [{"color": "#ae9e90"}]},{"featureType": "landscape.natural","elementType": "geometry","stylers": [{"color": "#dfd2ae"}]},{"featureType": "poi","elementType": "geometry","stylers": [{"color": "#dfd2ae"}]},{"featureType": "poi","elementType": "labels.text.fill","stylers": [{"color": "#93817c"}]},{"featureType": "poi.park","elementType": "geometry.fill","stylers": [{"color": "#a5b076"}]},{"featureType": "poi.park","elementType": "labels.text.fill","stylers": [{"color": "#447530"}]},{"featureType": "road","elementType": "geometry","stylers": [{"color": "#f5f1e6"}]},{"featureType": "road.arterial","elementType": "geometry","stylers": [{"color": "#fdfcf8"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"color": "#f8c967"}]},{"featureType": "road.highway","elementType": "geometry.stroke","stylers": [{"color": "#e9bc62"}]},{"featureType": "road.highway.controlled_access","elementType": "geometry","stylers": [{"color": "#e98d58"}]},{"featureType": "road.highway.controlled_access","elementType": "geometry.stroke","stylers": [{"color": "#db8555"}]},{"featureType": "road.local","elementType": "labels.text.fill","stylers": [{"color": "#806b63"}]},{"featureType": "transit.line","elementType": "geometry","stylers": [{"color": "#dfd2ae"}]},{"featureType": "transit.line","elementType": "labels.text.fill","stylers": [{"color": "#8f7d77"}]},{"featureType": "transit.line","elementType": "labels.text.stroke","stylers": [{"color": "#ebe3cd"}]},{"featureType": "transit.station","elementType": "geometry","stylers": [{"color": "#dfd2ae"}]},{"featureType": "water","elementType": "geometry.fill","stylers": [{"color": "#b9d3c2"}]},{"featureType": "water","elementType": "labels.text.fill","stylers": [{"color": "#92998d"}]}];
var mapMarkers = [], markersInfo = [], vinhasSwipers = [];
